import { Component, Input } from '@angular/core';
import { ChecksComponent } from '../../../../../processes/components/checks/checks.component';
import { CHECK, IProcessDetailResponse } from '../../../../../processes/models/processes.models';

@Component({
	selector: 'app-operation-pol-checks-antifraud',
	imports: [ChecksComponent],
	templateUrl: './operation-pol-checks-antifraud.component.html',
	styleUrl: './operation-pol-checks-antifraud.component.scss',
})
export class OperationPolChecksAntifraudComponent {
	@Input({ required: true }) checksDetail!: IProcessDetailResponse;
	@Input({ required: true }) checks!: (CHECK | undefined)[];
}
